import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

import {
	AlarisApiService,
	AlarisEnumEntry,
	AlarisLanguageService,
	ErrorNotifierConfig,
	ExtendableRefBookService,
	sortData,
} from '@campaign-portal/components-library';
import { ReadResponse } from '@campaign-portal/namespace/common/implementations';
import { exist } from '@campaign-portal/namespace/common/id';
import { Channel } from '@campaign-portal/namespace/entities/channels/specs';

@Injectable({
	providedIn: 'root',
})
export class ChannelsService extends ExtendableRefBookService<Channel<exist>> {
	readonly enums$ = new BehaviorSubject<AlarisEnumEntry[]>([]);

	constructor(
		private readonly api: AlarisApiService,
		private readonly langService: AlarisLanguageService
	) {
		super();
	}

	get title(): string {
		return this.langService.translate('notifications.titles.channel');
	}

	override load(): Observable<ReadResponse<Channel<exist>[]>> {
		return this.api.loader<ReadResponse<Channel<exist>[]>>('Channels.Read', {}, this.loading$, this.errorNotifier).pipe(
			map((resp) => {
				sortData(resp.Data, 'name');
				this.processEnums(resp.Data);
				return super.process(resp);
			})
		);
	}

	private processEnums(channels: Channel<exist>[]): void {
		this.enums$.next(
			channels.map((channel) => ({
				name: channel.name,
				value: channel.channelType,
			}))
		);
	}

	private readonly errorNotifier = (): ErrorNotifierConfig => ({ title: this.title });
}
